import { isNil } from "lodash";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { percentageFilter } from "app/filters/ngFilters";

import { LOADER_HEIGHT, LOADER_WIDTH } from "../../constants";
import { shareKeys } from "../automationKeys";
import { ZERO } from "../constants";

import {
    StyledShareData,
    StyledSharePercent,
    StyledSharePercentPoint,
    StyledShareTitle,
    StyledShareWrapper,
} from "./styles";
import type { ShareSchema } from "./type";

export const Share = ({
    value = ZERO,
    change,
    label,
    isLoading,
    isDisabled,
    metric,
    withSpace = false,
    name = "share",
}: ShareSchema) => {
    const space = withSpace ? " " : "";
    const changeWithSymbols = percentageFilter()(change, 1);
    const isChange = !isNaN(change) && !isNil(change);

    return (
        <StyledShareWrapper data-automation={shareKeys.wrapper(name)}>
            <StyledShareTitle data-automation={shareKeys.title(name)}>{label}</StyledShareTitle>

            {isLoading ? (
                <span data-automation={shareKeys.preLoader}>
                    <PixelPlaceholderLoader
                        height={LOADER_HEIGHT}
                        width={LOADER_WIDTH}
                    />
                </span>
            ) : (
                <StyledShareData data-automation={shareKeys.data(name)}>
                    <StyledSharePercent data-automation={shareKeys.percents(name)}>{value}</StyledSharePercent>

                    {isChange ? (
                        <StyledSharePercentPoint>
                            <ChangeIndication
                                className="customChangeIndication"
                                changeValue={`${changeWithSymbols}${space}${metric}`}
                                isIncreasing={change > ZERO}
                                isNotChanged={isDisabled || change === ZERO}
                                dataAutomation={shareKeys.change(name)}
                            />
                        </StyledSharePercentPoint>
                    ) : null}
                </StyledShareData>
            )}
        </StyledShareWrapper>
    );
};

Share.displayName = "Share";
